import React, {Component} from 'react'
import {Button, Form, Grid, Header, Segment, Message} from 'semantic-ui-react'
import {bindActionCreators} from "redux";
import {actionCreators} from "../../store/Login";
import {connect} from "react-redux";
import queryString from 'query-string'

class Login extends Component {
    constructor(props) {
        super(props)
        let query = queryString.parse(props.location.search)
        this.state = {
            email: "",
            password: "",
            errorMessage: null,
            successMessage: null,
            token: query.token
        }
    }

    componentWillMount() {
        if (this.state.token) {
            this.handleSubmit()
        }
    }

    async handleSubmit() {
        let response = await this.props.unlockAccount(this.state)
        this.handleResponse(response);
    }

    handleResponse(response) {
        let errors = response.data.errors
        if (!errors) {
            let successMessage = <p>{response.data.message}</p>
            this.setState({successMessage, errorMessage: null, loading: false})
        } else {
            let errorMessage = Array.isArray(errors) ? errors.map((error, index) => {
                return <p key={index}>{error.message}</p>
            }) : <p>{response.data.message}</p>
            this.setState({successMessage: null, errorMessage, loading: false})

        }
    }

    handleChange(field, e) {
        let state = this.state
        state[field] = e.target.value
        this.setState(state)
    }

    async handleResend() {
        let response = await this.props.resendUnlock(this.state)
        this.handleResponse(response);
    }

    render() {
        return (
            <Grid textAlign='center' style={{height: '100vh'}} verticalAlign='middle'>
                <Grid.Column style={{maxWidth: 450}}>

                    <Form size='large'>
                        <Segment padded='very'  stacked>
                            {this.state.errorMessage ? <Message negative>
                                <Message.Header>There was some errors with your submission</Message.Header>
                                {this.state.errorMessage}
                            </Message> : this.state.successMessage ? <Message positive key={1}>
                                <Message.Header>Success!</Message.Header>
                                {this.state.successMessage}
                                <a href='/'>Click here </a> to login
                            </Message> : null}
                            <Header as='h2' color='teal' textAlign='center'> Unlock Account
                            </Header>
                            {this.state.errorMessage ? [
                                <Form.Input key={1} fluid icon='user' iconPosition='left' placeholder='E-mail address'
                                            onChange={this.handleChange.bind(this, 'email')}/>,
                                <Button key={2} color='teal' fluid size='large' onClick={this.handleResend.bind(this)}>
                                    Resend Unlock Code
                                </Button>] : null}
                        </Segment>
                    </Form>
                </Grid.Column>
            </Grid>
        )
    }
}

export default connect(
    state => {
        const {login} = state;
        return {
            state: {login}
        };
    },
    dispatch => bindActionCreators(actionCreators, dispatch)
)(Login);
